export class Imagen {
    constructor(public small:string, public medium:string, public big:string){}
}
